import React from "react";
import { Box, Typography, Grid, useTheme, useMediaQuery } from "@mui/material";
import {
  IMG_TSHIRT_BEIGE_LOGO_RED,
  IMG_TSHIRT_BEIGE_LOGO_RED_GIRL1,
  IMG_TSHIRT_BEIGE_LOGO_RED_GIRL2,
  IMG_TSHIRT_BEIGE_LOGO_RED_GIRL3,
  IMG_TSHIRT_BEIGE_LOGO_RED_BOY,
  IMG_TSHIRT_BEIGE_BACK,
  IMG_TSHIRT_BEIGE_LOGO_BLACK,
  IMG_TSHIRT_BEIGE_LOGO_BLACK_GIRL,
  IMG_TSHIRT_BEIGE_LOGO_BLACK_BOY,
  IMG_TSHIRT_BEIGE_LOGO_WHITE_GIRL
} from "./imageConfig";
import { useNavigate } from "react-router-dom";

const ShopTheLook = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const navigate = useNavigate();

  const clothes = [
    {
      id: 101,
      title: "DAINASOUL T-Shirt | Beige | Logo Red",
      price: "₹1,999.00",
      prices: {
        US: "$25.00",
        CA: "CAD $35.00",
        IN: "₹1,999.00",
        EU: "€25.00",
        GB: "£20.00",
        AU: "$39.00",
        default: "$25.00",
      },
      image: IMG_TSHIRT_BEIGE_LOGO_RED,
      images: [IMG_TSHIRT_BEIGE_LOGO_RED, IMG_TSHIRT_BEIGE_LOGO_RED_GIRL1, IMG_TSHIRT_BEIGE_LOGO_RED_GIRL2, IMG_TSHIRT_BEIGE_LOGO_RED_GIRL3, IMG_TSHIRT_BEIGE_LOGO_RED_BOY, IMG_TSHIRT_BEIGE_BACK],
      color: "Beige",
      category: "t-shirt",
      isComingSoon: false,
      isSoldOut: false,
      shipping: "Free shipping worldwide",
      colors: ["#ebdfd3", "#ff0000"],
    },
    {
      id: 102,
      title: "DAINASOUL T-Shirt | Beige | Logo Black",
      price: "₹1,999.00",
      prices: {
        US: "$25.00",
        CA: "CAD $35.00",
        IN: "₹1,999.00",
        EU: "€25.00",
        GB: "£20.00",
        AU: "$39.00",
        default: "$25.00",
      },
      image: IMG_TSHIRT_BEIGE_LOGO_BLACK,
      images: [IMG_TSHIRT_BEIGE_LOGO_BLACK, IMG_TSHIRT_BEIGE_LOGO_BLACK_GIRL, IMG_TSHIRT_BEIGE_LOGO_BLACK_BOY, IMG_TSHIRT_BEIGE_BACK],
      color: "Beige",
      category: "t-shirt",
      isComingSoon: false,
      isSoldOut: false,
      shipping: "Free shipping worldwide",
      colors: ["#ebdfd3", "#000000"],
    }
  ];

  const handleCardClick = (product) => {
    const slug = product.title
      .toLowerCase()
      .replace(/\s*\|\s*/g, "-")
      .replace(/\s+/g, "-");

    navigate(`/product-description/${slug}`, {
      state: { product }
    });
  };

  return (
    <Box sx={{ mt: { xs: 8, md: 10 }, mb: { xs: 8, md: 10 }, mx: { xs: -2, md: -4 } }}>
      <Grid container spacing={0}>
        {/* Left: Large Lifestyle Image */}
        <Grid item xs={12} md={6}>
          <Box sx={{ position: "relative", height: { xs: "500px", md: "800px" }, overflow: "hidden" }}>
            <Box
              component="img"
              src={IMG_TSHIRT_BEIGE_LOGO_WHITE_GIRL}
              alt="Shop The Look Lifestyle"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                backgroundColor: "rgba(0,0,0,0.05)",
                pl: { xs: 5, md: 8 },
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  color: "#fff",
                  fontFamily: '"Playfair Display", serif',
                  fontSize: { xs: "42px", md: "65px" },
                  fontWeight: 400,
                  letterSpacing: "0.02em",
                  textAlign: "left",
                  textShadow: "0 2px 10px rgba(0,0,0,0.1)",
                }}
              >
                SHOP THE LOOK
              </Typography>
            </Box>
          </Box>
        </Grid>

        {/* Right: Two Adjacent Product Cards */}
        <Grid item xs={12} md={6} sx={{ pt: { xs: 5, md: 0 } }}>
          <Grid container spacing={0} sx={{ height: "100%" }}>
            {clothes.map((item, index) => {
              const [brand, ...rest] = item.title.split(" ");
              const restTitle = rest.join(" ").replace(/\|/g, "");

              return (
                <Grid
                  item
                  xs={6}
                  key={index}
                >
                  <Box
                    onClick={() => handleCardClick(item)}
                    sx={{
                      px: { xs: 1, md: 2 },
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      cursor: "pointer",
                    }}
                  >
                    {/* Image */}
                    <Box
                      sx={{
                        width: "100%",
                        height: { xs: "300px", sm: "460px", md: "560px" },
                        mb: 3,
                        overflow: "hidden",
                      }}
                    >
                      <Box
                        component="img"
                        src={item.image}
                        alt={item.title}
                        sx={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover", // 🔥 more premium than contain
                          transition: "transform 0.6s ease",
                          "&:hover": {
                            transform: "scale(1.08)",
                          },
                        }}
                      />
                    </Box>

                    {/* Text */}
                    <Box>
                      <Typography
                        sx={{
                          fontSize: { xs: "11px", md: "14px" },
                          display: "flex",
                          flexDirection: { xs: "column", md: "row" },
                          alignItems: { xs: "flex-start", md: "center" },
                          flexWrap: "wrap",
                          lineHeight: 1.5,
                          mb: 0.5,
                          mt: 1.5,
                          ml: { xs: 2.5, md: 2 }
                        }}
                      >
                        {/* Brand */}
                        <Box
                          component="span"
                          sx={{
                            fontFamily: '"Playfair Display", serif',
                            mr: { xs: 0, md: 0.5 },
                            mb: { xs: 0.5, md: 0 },
                            letterSpacing: "0.5px",
                          }}
                        >
                          {brand}
                        </Box>

                        {/* Product */}
                        <Box
                          component="span"
                          sx={{
                            fontFamily: "sans-serif",
                            color: "#333",
                          }}
                        >
                          {restTitle}
                        </Box>
                      </Typography>

                      {/* Price */}
                      <Typography
                        sx={{
                          fontSize: { xs: "11px", md: "13px" },
                          color: "#666",
                          mb: 1.5,
                          ml: { xs: 2.5, md: 2 }
                        }}
                      >
                        {item.price}
                      </Typography>

                      {/* Color Swatches */}
                      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', ml: { xs: 2.5, md: 2 }, mb: 2 }}>
                        {item.colors?.map((color, index) => (
                          <Box
                            key={index}
                            sx={{
                              width: { xs: 12, md: 14 },
                              height: { xs: 12, md: 14 },
                              borderRadius: '50%',
                              backgroundColor: color,
                              border: '1px solid #eee',
                              cursor: 'default'
                            }}
                          />
                        ))}
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ShopTheLook;
